import React, { useEffect, useState } from 'react';
import { initAnalytics, updateConsent, disableAnalytics } from '../utils/analytics';
import Button from './buttons/Button';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const accepted = window.localStorage.getItem('cookie_accepted');
      if (accepted === null) setVisible(true);
    } catch (e) { /* ignore */ }
  }, []);

  const accept = () => {
    try {
      window.localStorage.setItem('cookie_accepted', '1');
      updateConsent(true);
      initAnalytics(true);
    } catch (e) { /* ignore */ }
    setVisible(false);
  };

  const reject = () => {
    try {
      window.localStorage.setItem('cookie_accepted', '0');
      updateConsent(false);
      disableAnalytics();
    } catch (e) { /* ignore */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{ background: 'var(--panel)', color: 'var(--text)', border: '1px solid var(--border)' }} className="fixed bottom-4 inset-x-4 md:inset-x-24 shadow-lg rounded-lg p-4 flex flex-col md:flex-row items-center justify-between gap-4 z-50">
      <div className="text-sm">
        Używamy plików cookie do analityki i ulepszania serwisu. Akceptujesz korzystanie z plików cookie?
      </div>
      <div className="flex gap-2">
        <Button variant="ghost" className="px-3 py-1 text-sm" onClick={reject}>Odrzuć</Button>
        <Button className="px-3 py-1 text-sm" onClick={accept}>Akceptuję</Button>
      </div>
    </div>
  );
}
